// frontend/src/components/common/LoadingSpinner.jsx

import React from 'react';

function LoadingSpinner({ text = 'Carregando...' }) {
  return (
    <div className="d-flex justify-content-center align-items-center my-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <span className="ms-3">{text}</span>
    </div>
  );
}

export default LoadingSpinner;